import { render, staticRenderFns } from "./MetricCategoryEdit.vue?vue&type=template&id=7746b556"
import script from "./MetricCategoryEdit.vue?vue&type=script&lang=js"
export * from "./MetricCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports